// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"4c12484e","488":"ad269f44"}[chunkId] + ".chunk.js";
};